import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

// components
import PillSection from 'feature/loading-management/create-new-common/PillSection';
import { withVerticalMarginStyles } from 'feature/loading-management/create-new-common/CreateNewCommon.styles';

import { EvaluateFlag } from 'common/FeatureFlags/Flag';
import DropDownSection from './DropDownSection';
import VariableFields from './VariableFields';

// Utils
import { STEP_ONE_HEADER } from '../../../utils/const';

const Details = ({
  authorizationBy,
  currentSelection,
  inventoryOwner,
  fetchLocations,
  fetchProducts,
  fetchSuppliers,
  params,
  setParams,
  setHasUnsavedChanges,
  setViewByList,
  setViewByListFetched,
  setWizardDetails,
  supplierListOptions,
  viewById,
  viewByListFetched,
  viewByListOptions,
}) => {
  const handleTypeChange = e => {
    setHasUnsavedChanges(true);
    setWizardDetails({ name: 'authorizationBy', value: e.target.value });
    setWizardDetails({ name: 'viewById', value: null });
  };
  const isCreateSupplierAuthorizationsEnabled = EvaluateFlag(
    process.env.REACT_APP_LD_CREATE_SUPPLIER_AUTHORIZATIONS
  );

  return (
    <>
      {isCreateSupplierAuthorizationsEnabled && <Divider sx={withVerticalMarginStyles} />}
      <Box display="flex" flexDirection="column" pt={2} px={3}>
        <Typography color="textPrimary" fontWeight={700} variant="body1">
          {isCreateSupplierAuthorizationsEnabled ? 'Authorization Setup Type' : STEP_ONE_HEADER}
        </Typography>
        {isCreateSupplierAuthorizationsEnabled ? (
          <FormControl>
            <RadioGroup
              name="radio-buttons-group"
              onChange={handleTypeChange}
              sx={{ mt: 1, px: 1 }}
              value={authorizationBy}
            >
              <FormControlLabel control={<Radio />} label="By Location" value="location" />
              <FormControlLabel control={<Radio />} label="By Product" value="product" />
            </RadioGroup>
          </FormControl>
        ) : (
          <PillSection
            name="selfAuthorizationsType"
            onTypeChange={handleTypeChange}
            typeSelection={authorizationBy}
          />
        )}
        <Divider
          sx={{
            ...withVerticalMarginStyles,
            opacity: 0.6,
          }}
        />
        <DropDownSection
          authorizationBy={authorizationBy}
          currentSelection={currentSelection}
          fetchLocations={fetchLocations}
          fetchProducts={fetchProducts}
          fetchSuppliers={fetchSuppliers}
          inventoryOwner={inventoryOwner}
          setHasUnsavedChanges={setHasUnsavedChanges}
          setParams={setParams}
          setViewByList={setViewByList}
          setViewByListFetched={setViewByListFetched}
          setWizardDetails={setWizardDetails}
          supplierIdName={params.supplierIdName}
          supplierListOptions={supplierListOptions}
          viewById={viewById}
          viewByListOptions={viewByListOptions}
        />
        <Box sx={{ mt: 2 }}>
          <VariableFields
            authorizationBy={authorizationBy}
            currentSelection={currentSelection}
            params={params}
            setHasUnsavedChanges={setHasUnsavedChanges}
            setParams={setParams}
            setWizardDetails={setWizardDetails}
            viewById={viewById}
            viewByListFetched={viewByListFetched}
            viewByListOptions={viewByListOptions}
          />
        </Box>
      </Box>
    </>
  );
};

export default Details;

Details.propTypes = {
  authorizationBy: string.isRequired,
  currentSelection: shape({}),
  fetchLocations: func.isRequired,
  fetchProducts: func.isRequired,
  fetchSuppliers: func.isRequired,
  inventoryOwner: shape({
    companyCustomerIdName: string,
    dataCompanyId: number,
  }),
  params: shape({}),
  setHasUnsavedChanges: func.isRequired,
  setParams: func.isRequired,
  setViewByList: func.isRequired,
  setViewByListFetched: func.isRequired,
  setWizardDetails: func.isRequired,
  supplierListOptions: arrayOf(
    shape({
      dataCompanyId: number,
      label: string,
      value: string,
    })
  ),
  viewById: number,
  viewByListFetched: bool,
  viewByListOptions: arrayOf(
    shape({
      label: string,
      value: number,
    })
  ),
};

Details.defaultProps = {
  currentSelection: {},
  inventoryOwner: {},
  params: {},
  supplierListOptions: [],
  viewById: null,
  viewByListFetched: false,
  viewByListOptions: [],
};
